import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useState } from "react";

export default ({ images }: { images: any }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>(null);

  if (!images || images.length === 0) {
    return null;
  }

  const handleImageClick = (img: any) => {
    setSelectedImage(img);
    setPreviewOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          overflowX: "auto",
          pb: 2,
          mb: 2,
        }}
      >
        {images.map((img: any, index: number) => (
          <Box
            key={index}
            component="img"
            src={img.url}
            alt={`Image ${index + 1}`}
            onClick={() => handleImageClick(img)}
            sx={{
              flexShrink: 0,
              height: 200,
              width: 200,
              objectFit: "cover",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "divider",
              cursor: "pointer",
              transition: "opacity 0.2s",
              "&:hover": {
                opacity: 0.85,
              },
            }}
          />
        ))}
      </Box>

      {/* Image Preview Dialog */}
      <Dialog
        maxWidth="xl"
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
      >
        <DialogTitle>
          Image Preview
          <IconButton
            onClick={() => setPreviewOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedImage && (
            <Box
              component="img"
              src={selectedImage.url}
              alt="Preview"
              sx={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
